<template>
  <div class="body-box marginBox">
    <!-- 搜索与添加区域 -->
    <el-row class="plan">
      <el-col :span="19">
        <el-button icon="el-icon-plus" @click="addCustomGoods">新增</el-button>
      </el-col>
      <el-col :span="5">
        <search-input v-model="queryInfo.keyword" placeholder="请输入关键字进行搜索" @change="handleQuery"/>
      </el-col>
    </el-row>

    <el-table :height="'calc(100% - 70px)'" :data="customGoodsList" class="button-box">
      <el-table-column label="定制商品名称" prop="name"></el-table-column>
      <el-table-column label="缩略图" prop="thumbnail">
        <template slot-scope="scope">
          <icon-img :icon="scope.row.thumbnail"></icon-img>
        </template>
      </el-table-column>
      <el-table-column label="排序" prop="sort"></el-table-column>
      <el-table-column label="操作" min-width="100" fixed="right">
        <template slot-scope="scope">
          <el-popover placement="right" trigger="click">
            <div class="foldBtnBox">
              <div><el-button icon="el-icon-edit" @click="editCustomGoods(scope.row)">修改</el-button></div>
              <div><el-button icon="el-icon-delete" @click="removeCustomGoodsById(scope.row.id)">删除</el-button></div>
            </div>
            <el-button slot="reference">更多操作</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页区域 -->
    <div class="fixedBox"><pagination ref="page" :query-param.sync='queryInfo' @pagination="getCustomGoodsList"/></div>
    <addCustomGoods @refresh-list="handleQuery" ref="addCustomGoods"></addCustomGoods>
    <editCustomGoods @refresh-list="handleQuery" ref="editCustomGoods"></editCustomGoods>
  </div>
</template>
<script>
import Pagination from '@/components/common/Pagination/index'
import addCustomGoods from "@/views/customGoods/addCustomGoods";
import editCustomGoods from "@/views/customGoods/editCustomGoods";
import { getPostOrDeleteData} from "@/utils/code";
import {deleteCustomGoods, getCustomGoodsList} from "@/api/customGoods/customGoods";
import {deleteTips, title} from "@/utils/tips";
import SearchInput from '@/components/common/searchInput/searchInput'
import IconImg from '@/components/common/pictureImg/index'

export default {
  components: { IconImg, SearchInput, Pagination, addCustomGoods, editCustomGoods},
  data() {
    return {
      queryInfo: {
        keyword: "",
      },
      customGoodsList: []
    };
  },
  mounted() {
    this.handleQuery()
  },
  created() {

  },
  methods: {
    //查询列表
    getCustomGoodsList(page, cb) {
      getCustomGoodsList(page).then((response) => {
        this.customGoodsList = cb(response)
      })
    },

    //根据ID删除数据
    async removeCustomGoodsById(id) {
      let b = await deleteTips(title.deleteTitle);
      if (b) {
        deleteCustomGoods(id).then((response) => {
          let data = getPostOrDeleteData(response);
          if (data !== null) {
            this.handleQuery()
          }
        })
      }
    },

    //新增
    addCustomGoods() {
      this.$refs.addCustomGoods.addDialog()
    },

    //修改
    editCustomGoods(row) {
      this.$refs.editCustomGoods.editDialog(row)
    },

    //查询按钮
    handleQuery() {
      this.$nextTick(() => {
        this.$refs.page.run()
      })
    },

  },
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog {
  padding-right: 30px;
}
</style>
